module.exports = __webpack_public_path__ + "img/icon_exchange_congratulations.4b0a7912.png";